<template>
  <div class="step-content" :class="{'close-by': useCaptureUrl}">
    <ul class="content__advance--wrap" :style="{'margin-bottom': '40px'}" v-if="bAMPUser">
      <li class="content__advance content__bAMP icon--bg-dash"
          :disabled="!allowBAMP">
        <p class="content__desc">
          {{ $t('page.registration.step1.amp.label') }}
        </p>
        <div class="label--wrap">
          <ui-tooltip :arrowCenter="true" :style="{top:'-85px', left:'-110px'}" v-if="showBAMPTooltip">
            <span v-html="$t('page.registration.step1.amp.tooltip')"></span>
          </ui-tooltip>
          <label for="bAMPTrue" @mouseenter="showBAMPTooltip = true" @mouseleave="showBAMPTooltip = false" :class="{disabled : !bAMPAvailable}">
            <input type="radio" name="bAMP" value="true" id="bAMPTrue" :checked="bAMP" :disabled="isEditMode || !bAMPAvailable"
                   @change="$emit('update:bAMP', true)"><i class="icon icon--radio-off"></i>
            <span>{{ $t('common.yes') }}</span>
          </label>
          <label for="bAMPFalse" :class="{disabled : !bAMPAvailable}">
            <input type="radio" name="bAMP" value="false" id="bAMPFalse" :checked="!bAMP" :disabled="isEditMode || !bAMPAvailable"
                   @change="$emit('update:bAMP', false)"><i class="icon icon--radio-off"></i>
            <span>{{ $t('common.no') }}</span>
          </label>
        </div>
      </li>
    </ul>

    <div class="content__match-type">
      <p class="label"><span>{{ $t('page.registration.step1.labelMatchType') }}</span></p>
      <ui-selectbox :value="matchType"
                    :items="matchTypeOptions"
                    :disabled="isEditMode || bAMP || isABPlan"
                    width="100%"
                    class="match-option--wrap"
                    @input="$emit('update:matchType', $event)" />
    </div>

    <div class="content__url" v-if="!requireDomain">
      <div class="input--wrap">
        <p class="label"><label for="url">{{ $t(matchTypeData.labelKey) }}</label></p>
        <input required
               id="url"
               type="text"
               :value="url"
               :class="{error: urlError && url.length}"
               :placeholder="matchTypeData.urlPlaceholder"
               :disabled="isEditMode"
               @focus="showUrlGuide = true, onSetPageAddFocusContent(2, 'matchType')"
               @blur="showUrlGuide = false, isUrlValidatorEnabled = true, $emit('overlapUrlCheck')"
               @input="$emit('update:url', $event.target.value.trim())" >
        <i class="icon icon--check-green-size16"></i>
        <i v-if="!isEditMode" class="icon icon--close14" @click="$emit('update:url', '')"></i>
        <ui-tooltip v-show="showUrlGuide" class="url-guide-tooltip" arrowCenter noApplyCenterAnimate>
          <span v-html="$t('page.registration.step1.url.guide1')"/>
          <br><br>
          <span v-html="$t('page.registration.step1.url.guide2')"/>
        </ui-tooltip>
        <span v-if="urlError && isUrlValidatorEnabled && url.length" class="validation-text">
          {{ $t(`common.validationErrorText.${urlError}`) }}
        </span>
      </div>
      <ui-button class="btn-match-result"
                 :disabled="isMatchPreviewDisabled ? true : false"
                 @click.stop="$emit('update:showMatchTypeGuide', true)">
        {{ $t('common.matchConfirm') }}
      </ui-button>
    </div>

    <div v-else class="content__domain content__criterion">
      <div class="input--wrap domain">
        <p class="label"><label for="domain">{{ $t(matchTypeData.labelKey) }}</label></p>
        <input required
               id="domain"
               type="text"
               :value="url"
               :class="{error: urlError && url.length}"
               :placeholder="matchTypeData.urlPlaceholder"
               :disabled="isEditMode"
               @focus="showUrlGuide = true, onSetPageAddFocusContent(2, 'matchType')"
               @blur="showUrlGuide = false"
               @input="$emit('update:url', $event.target.value.trim())">
        <ui-tooltip v-show="showUrlGuide" class="url-guide-tooltip" arrowCenter noApplyCenterAnimate>
          <span v-html="$t('page.registration.step1.url.guide2')"/>
        </ui-tooltip>
        <span v-if="urlError && isUrlValidatorEnabled && url.length" class="validation-text">
          {{ $t(`common.validationErrorText.${urlError}`) }}
        </span>
      </div>

      <div class="input--wrap content__matchType">
        <p class="label"><label for="criterion">{{ $t(matchTypeData.matchStringLabelKey) }}</label></p>
        <input required id="criterion" type="text"
               :class="{error: matchStringError && matchString.length}"
               :value="matchString"
               :placeholder="matchTypeData.matchStringPlaceholder"
               :disabled="isEditMode"
               @focus="onSetPageAddFocusContent(2, 'matchType')"
               @blur="isMatchStringValidatorEnabled = true"
               @input="$emit('update:matchString', $event.target.value.trim())">
        <span v-if="matchStringError && isMatchStringValidatorEnabled && matchString.length" class="validation-text">
          {{ $t(`common.validationErrorText.${matchStringError}`) }}
        </span>
      </div>

      <button v-if="matchType !== 'regexp'"
              class="btn-match-result"
              :disabled="isMatchPreviewDisabled"
              @click.stop="$emit('update:showMatchTypeGuide', true)">{{ $t('common.matchConfirm') }}</button>
    </div>

    <match-type-guide
      v-if="showMatchTypeGuide"
      :requireDomain="requireDomain"
      :enteredMatchType="matchType"
      :enteredURL="url"
      :enteredCriterion="matchString"
      :enteredSiteCode="urlSiteCode"
      @closeLayer="$emit('update:showMatchTypeGuide', false)"/>

    <ul class="content__advance--wrap">
      <li class="content__advance content__bLogin icon--bg-dash"
          :disabled="!allowBLogin">
        <p class="content__desc">
          {{ $t('page.registration.step1.bLogin.label') }}
          <ui-icon-tooltip arrowCenter
            :forceShowText="showBLoginTooltip">
            <span v-html="$t('page.registration.step1.bLogin.tooltip')"></span>
          </ui-icon-tooltip>
        </p>
        <div class="label--wrap"
          @mouseenter="showBLoginTooltip = !allowBLogin"
          @mouseleave="showBLoginTooltip = false">
          <ui-tooltip :arrowCenter="true" :style="{top:'-75px', left:'-100px'}" v-if="bAMP && showBAMPTooltipBLogin">
            <span v-html="$t('page.registration.step1.amp.blogincheck')"></span>
          </ui-tooltip>
          <label for="bLoginTrue"  @mouseenter="showBAMPTooltipBLogin = true" @mouseleave="showBAMPTooltipBLogin = false" :class="{disabled : bAMP}">
            <input type="radio" name="bLogin" value="true" id="bLoginTrue" :checked="bLogin" :disabled="bAMP"
              @change="onLoginChange($event, true)"><i class="icon icon--radio-off"></i>
            <span>{{ $t('common.yes') }}</span>
          </label>
          <label for="bLoginFalse">
            <input type="radio" name="bLogin" value="false" id="bLoginFalse" :checked="!bLogin"
              @change="onLoginChange($event, false)"><i class="icon icon--radio-off"></i>
            <span>{{ $t('common.no') }}</span>
          </label>
        </div>

        <div v-if="!bLogin" :class="{on: !bLogin}" class="content--wrap" >
          <div class="input--wrap">
            <p class="label">
              <label>{{ $t('page.registration.step1.bLogin.capturelabel') }}</label>
              <label style="margin-left: 5px; font-size: 12px;">{{ $t('page.registration.step1.bLogin.require') }}</label>
            </p>
            <input type="text" :placeholder="$t('page.registration.step1.bLogin.placeholder')"
                   :class="{error: captureUrlError && captureUrl.length}"
                   :value="captureUrl"
                   @focus="onSetPageAddFocusContent(2, 6)"
                   @blur="isCaptureUrlValidatorEnabled = true"
                   @input="$emit('update:captureUrl', $event.target.value.trim())">
            <span v-if="captureUrlError && isCaptureUrlValidatorEnabled && captureUrl.length"
                  class="validation-text">
              {{ $t(`common.validationErrorText.${captureUrlError}`) }}
            </span>
          </div>
        </div>
      </li>

      <li class="content__advance content__isOnlyPhone icon--bg-dash">
        <p class="content__desc">{{ $t('page.registration.step1.device.label') }}</p>
        <div class="label--wrap">
          <label for="isOnlyPhoneTrue">
            <input type="radio" name="bMobile" value="true" id="isOnlyPhoneTrue" :checked="bMobile"
              @change="$emit('update:bMobile', true)"><i class="icon icon--radio-off"></i>
            <span>{{ $t('common.yes') }}</span>
          </label>
          <label for="isOnlyPhoneFalse">
            <input type="radio" name="bMobile" value="false" id="isOnlyPhoneFalse" :checked="!bMobile"
              @change="$emit('update:bMobile', false)"><i class="icon icon--radio-off"></i>
            <span>{{ $t('common.no') }}</span>
          </label>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import UiButton from '@/components/ui/UiButton'
import UiSelectbox from '@/components/ui/UiSelectbox'
import UiTooltip from '@/components/ui/UiTooltip'
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import MatchTypeGuide from '@/components/page-registration/MatchTypeGuide'

export default {
  name: 'RegistrationStep1',
  components: {
    UiButton,
    UiSelectbox,
    UiTooltip,
    UiIconTooltip,
    MatchTypeGuide
  },
  props: [
    'isEditMode',
    'matchTypeOptions',
    'matchTypeData',
    'matchType',
    'url',
    'urlSiteCode',
    'captureUrl',
    'matchString',
    'bLogin',
    'bMobile',
    'showMatchTypeGuide',
    'useCaptureUrl',
    'requireDomain',
    'urlError',
    'matchStringError',
    'captureUrlError',
    'bAMP',
    'bAMPUser'
  ],
  data () {
    return {
      bAMPAvailable: false,
      showUrlGuide: false,
      isUrlValidatorEnabled: this.url.length,
      isMatchStringValidatorEnabled: this.matchString.length,
      isCaptureUrlValidatorEnabled: this.captureUrl.length,
      showBLoginTooltip: false,
      showBAMPTooltip: false,
      showBAMPTooltipBLogin: false
    }
  },
  computed: {
    ...mapState([
      'planData',
      'isABPlan'
    ]),
    isMatchPreviewDisabled () {
      return this.matchType === 'regexp' || this.urlError || this.matchStringError
    },
    allowBLogin () {
      return this.planData.feature.bLogin
    },
    allowBAMP () {
      return true
    }
  },
  watch: {
    url () {
      this.isUrlValidatorEnabled = this.url.length
    },
    matchType () {
      this.onSetPageAddFocusContent(2, 'matchType')
      this.bAMPAvailableCheck()

      if (!this.isEditMode) {
        this.$emit('update:matchString', '')
        this.$emit('update:url', '')
        this.$emit('update:captureUrl', '')
      }
    },
    bLogin () {
      this.onSetPageAddFocusContent(2, 7)
      this.bAMPAvailableCheck()
      if (this.bLogin) {
        this.$emit('update:captureUrl', '')
        this.$emit('update:useCaptureUrl', false)
      } else {
        this.$emit('update:useCaptureUrl', true)
      }
    },
    bMobile () {
      this.onSetPageAddFocusContent(2, 8)
    },
    bAMP () {
      if (this.bAMP) {
        if (this.matchType === 'simple' && this.bLogin === false) {
          this.$emit('update:bAMP', this.bAMP)
          this.$emit('update:matchType', 'simple')
          this.$emit('update:bLogin', false)
        } else {
          this.$emit('bAMP', false)
        }
      }
    }
  },
  created () {
    this.bAMPAvailableCheck()
  },
  methods: {
    ...mapMutations([
      'setPageAddGuideContent'
    ]),
    bAMPAvailableCheck () {
      if (this.matchType === 'simple' && this.bLogin === false) {
        this.bAMPAvailable = true
      } else {
        this.bAMPAvailable = false
      }
    },
    onSetPageAddFocusContent (step, index) {
      if (index === 'matchType') {
        switch (this.matchType) {
          case 'exact':
            index = Number(0)
            break
          case 'simple':
            index = Number(1)
            break
          case 'start':
            index = Number(2)
            break
          case 'end':
            index = Number(3)
            break
          case 'contains':
            index = Number(4)
            break
          case 'regexp':
            index = Number(5)
            break
        }
      }
      const values = { currentStep: step, currentContentIndex: index }
      this.setPageAddGuideContent(values)
    },
    onLoginChange (event, value) {
      this.$emit('update:bLogin', value)
      this.$emit('update:useCaptureUrl', !value)
      this.onSetPageAddFocusContent(2, 6)

      if (value) {
        this.isCaptureUrlValidatorEnabled = false
        this.$emit('update:captureUrl', '')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.step-content {
  margin-top: 55px;
  padding-left: 70px;
  padding-right: 70px;
  margin-bottom: 57px;
}

.content__bAMP {
  .disabled {
    opacity: 0.5;
  }
}

.content__match-type {
  .match-option--wrap >>> .item--wrap{
    padding-left: 12px;
  }
  .refer-text {
    font-size: 12px;
    line-height: 1.5;
    color: #767676;
    li {
      position: relative;
      padding-left: 13px;
      margin-top: 5px;
      &:nth-of-type(1) {
        margin-top: 9px;
      }
      &:before {
        content: '';
        display: inline-block;
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background-color: #767676;
        position: absolute;
        top: 9px;
        left: 6px;
        transform: translateY(-50%);
      }
    }
  }
}

.content__url, .content__domain {
  @include flexXbetween;
  margin-top: 40px;
  .icon--check-green-size16.pass {
    display: inline-block;
    z-index: 1;
    background-color: #fff;
    border-radius: 12px;
  }
  .btn-match-result {
    @include buttonTypeNormal;
    overflow: visible;
    min-width: auto;
    border: 1px solid #bbbbbb;
    background-color: #ffffff;
    font-size: 14px;
    font-weight: bold;
    margin-top: 18px;
    margin-left: 5px;

    &:hover:after {
      border-radius: 20px;
    }
  }
  .url-guide-tooltip {
    display: inline-block;
    bottom: calc(100% - 2px);
    left: 160px;
    /deep/ .text {
      text-align: left;
      strong {
        color: $brandColor;
        font-weight: bold;
      }
    }
  }
  .speech-bubble {
    display: inline-block;
    bottom: calc(100% - 2px);
    left: 160px;
    .text {
      text-align: left;
      /deep/ strong {
        color: $brandColor;
        font-weight: bold;
      }
    }
  }
}

.content__url {
  position: relative;
  display: flex;
  justify-content: space-between;
  .input--wrap {
    display: block;
    width: 100%;
  }
  #url {
    width: 100%;
    &.pass { border-color: #3eaa08; }
    &.error { border-color: $errorColor; }
  }
}

.content__domain {
  #domain {
    width: 100%;
    &.error {
      border-color: $brandColor;
    }
  }

  .content__matchType {
    margin-left: 5px;
    #criterion {
      width: 100%;
      &.error {
        border-color: $brandColor;
      }
    }

    label,
    .validation-text {
      white-space: nowrap;
    }
  }

  &.content__criterion {
    .input--wrap.domain {
      width: 100%;
    }
  }
}

.content__advance--wrap {
  margin-top: 40px;

  .content__advance {
    margin-top: 28px;
    position: relative;

    &.content__setURL {
      .content--wrap {
        &.on {
          margin-bottom: 39px;
        }
        .input--wrap {
          width: 100%;
          margin-top: 21px;
          input[type=text] {
            width: 100%;

            &.error {
              border-color: $errorColor;
            }
          }
        }
      }
    }

    &.content__bLogin {
      .disabled {
        opacity: 0.5;
      }
      &[disabled] {
        /deep/ .tooltip {
          display: inline-block;
          height: 13px;
        }
        .label--wrap label {
          pointer-events: none;
          .icon {
            opacity: 0.3;
          }
        }
      }

      .content--wrap {
        &.on {
          margin-bottom: 39px;
        }
        .input--wrap {
          width: 100%;
          margin-top: 21px;
          input[type=text] {
            width: 100%;

            &.error {
              border-color: $errorColor;
            }
          }
        }
      }
    }

    &.content__bAMP {
      .tooltip {
        display: none;
      }
      &[disabled] {
        /deep/ .tooltip {
          display: inline-block;
          height: 13px;
        }
        .label--wrap label {
          pointer-events: none;
          .icon {
            opacity: 0.3;
          }
        }
      }
    }

    .content__desc {
      display: inline-block;
      font-size: 13px;
      font-weight: bold;
      color: #767676;
      position: relative;
      z-index: 1;
      background-color: #fff;
      padding: 0px 6px;

      /deep/ .tooltip {
        display: inline;
        .bubble {
          .text {
            display: inline;
          }
        }
      }
    }

    .label--wrap {
      float: right;
      position: relative;
      z-index: 1;
      background-color: #fff;
      padding-left: 3px;
      white-space: nowrap;

      label {
        position: relative;
        cursor: pointer;

        &:nth-last-of-type(1) {
          margin-left: 40px;
        }

        .icon {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }

        span {
          display: inline-block;
          padding-left: 26px;
          transform: translateY(1px);

          font-size: 14px;
          color: #2f2f2f;
        }
      }
    }
  }
}

.button--wrap {
  margin-top: 50px;
}
</style>
